"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmptyObject = void 0;
const isNullish_1 = require("./isNullish");
const isNonEmptyObject = (value) => {
    // Check if the value is an object and not null
    if (typeof value === "object" && !(0, isNullish_1.isNullish)(value)) {
        // Check if the object has any own properties
        return Object.keys(value).length > 0;
    }
    return false;
};
exports.isNonEmptyObject = isNonEmptyObject;
